import {
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel, Box, Text,
} from '@chakra-ui/react';
import React from 'react';
import { canShowAccordion, getAccordionVars, getButtonLabel, hasSection } from '../utils';
import EditButton from './EditButton';
import Index from './Notes';
import NotesUtils from './Notes/utils';
import Notes from './Notes';
import { getUsefulVars } from '../../../handlers/helpers';

const RSAccordion = ({ myData, props, previews, children, sectionName }) => {

  if (!hasSection(props, sectionName) && sectionName !== 'download') {
    return null;
  }
  const uv = getUsefulVars(props);
  const notesUtils = new NotesUtils(uv.stateProps,sectionName);
  const hasNotes = notesUtils.notes === undefined && !props.stateProps.isAdmin ? false : true;

  const [sectionObj, label, buttonLabel] = getAccordionVars(previews, sectionName, myData);
  if ( canShowAccordion(sectionObj, sectionName, myData)) {
    return (
      <Accordion allowToggle defaultIndex={[0]} className="accordion">
        <AccordionItem className="item">
          <AccordionButton className="accordionButton">
            <Heading className="heading sectionTitle">{label}</Heading>
            <AccordionIcon className="icon" />
          </AccordionButton>
          <AccordionPanel className="accordionPanel">
            <Box className="mainBox">
                {children}
            </Box>
          </AccordionPanel>
          <AccordionPanel className="accordionPanel" paddingBottom='0px' display='flex' justifyContent='flex-end'>
            {sectionName !== 'professional-experience' && (
              <EditButton props={props} buttonLabel={buttonLabel} target={sectionName} />

            )}
          </AccordionPanel>
          {hasNotes && (
          <AccordionPanel>
              <Box>
                <Box  position='absolute' marginTop='-2.2rem'  zIndex="100">
                <Text color={'blue'} textDecoration="underline"
                      onClick={(e) => notesUtils.open()}>Counselor Notes</Text>

                </Box>
                <Box data-id={sectionName + '_notes'}  >
                  <Notes props={props} notesUtils={notesUtils} />
                </Box>
              </Box>
          </AccordionPanel>
          )}
        </AccordionItem>
      </Accordion>
    );
  } else {
    return null;
  }
};
export default RSAccordion;